var exports = {
  "n": "xfd349460--18f1ca--link",
};

module.exports = exports;
